module.exports = __webpack_public_path__ + "img/plastic_bag_thumb.5bcdab56.jpg";